import { AdminProfileTabName } from './types'

export const adminProfileTabNames: Array<AdminProfileTabName> = ['calendly', 'assessments']
